export default __webpack_public_path__ + "locales/fi/ChangePhoneDialog.json?hash=26629aabad8b9a445bbccb38fa3a056b";